import Product from "@system/config/product";

class ResponseMaker {
    data = {};
    processed_payload = {
        value: []
    };
    constructor(data) {
        this.data = data;
        if (this.data && this.data && this.data.Products !== undefined) {
            this.data.products = this.data.Products;
        }
    }

    process = () => {
        return this;
    };

    run = () => {
        let value = [];
        if (this.data && this.data.products !== undefined &&
            this.data.products.length > 0
        ) {
            this.data.products.map((v, i) => {
                let here_v = {};
                here_v = v;
                if (here_v.ROHSCompliantCode !== undefined) {
                    here_v.ROHSCompliantCodeValue = Product.product__ROHSCompliantCode(here_v.ROHSCompliantCode);
                } else {
                    here_v.ROHSCompliantCodeValue = false;
                }
                if (here_v.NCNRFlag === 'No') {
                    here_v.NCNRFlag = false;
                }
                if (here_v.NCNRFlag === 'N') {
                    here_v.NCNRFlag = false;
                }
                if (here_v.NCNRFlag === 'Yes') {
                    here_v.NCNRFlag = true;
                }
                if (here_v.NCNRFlag === 'Y') {
                    here_v.NCNRFlag = true;
                }
                if (here_v.ObsoleteFlag === 'No') {
                    here_v.ObsoleteFlag = false;
                }
                if (here_v.ObsoleteFlag === 'N') {
                    here_v.ObsoleteFlag = false;
                }
                if (here_v.ObsoleteFlag === 'Yes') {
                    here_v.ObsoleteFlag = true;
                }
                if (here_v.ObsoleteFlag === 'Y') {
                    here_v.ObsoleteFlag = true;
                }
                if (here_v.EndofLifeFlag === 'No') {
                    here_v.EndOfLifeOFlag = false;
                    here_v.EndOfLifeFlag = false;
                }
                if (here_v.EndofLifeFlag === 'N') {
                    here_v.EndOfLifeOFlag = false;
                    here_v.EndOfLifeFlag = false;
                }
                if (here_v.EndofLifeFlag === 'Yes') {
                    here_v.EndOfLifeOFlag = true;
                    here_v.EndOfLifeFlag = true;
                }
                if (here_v.EndofLifeFlag === 'Y') {
                    here_v.EndOfLifeOFlag = true;
                    here_v.EndOfLifeFlag = true;
                }
                value[i] = here_v;
            })
            this.processed_payload.value = value;
        }
        return this;
    };

    get = () => {
        return {
            value: this.processed_payload.value
        };
    };
}
export default ResponseMaker;